import fetch from '@/helpers/fetch';

//根据部门获取用户信息

export function getUser(data) {
    return fetch.getFast('/api/staff/dep-users', data);
}